const React = require('react');
const T = require('prop-types');
const LoadingScreen = require('components/LoadingScreen');

const {
    useEffect,
    useState
} = React;

module.exports = function FallbackSpinner(props) {

    const {
        delay = 250,
        message = 'Loading...'
    } = props;

    const [shouldShow, setShouldShow] = useState(delay <= 0);

    useEffect(() => {

        if (delay <= 0) {
            setShouldShow(true);
            return undefined;
        }

        const timeout = window.setTimeout(() => {
            setShouldShow(true);
        }, delay);

        return () => window.clearTimeout(timeout);
    }, [delay]);

    if (!shouldShow) {
        return null;
    }

    return <LoadingScreen variant='content' message={message} />;
};

module.exports.propTypes = {
    delay: T.number,
    message: T.string
};
